import React,{useEffect,useState} from "react"
import {Form,Col} from 'react-bootstrap'

function Polysomnography(props){
    const [disabled,setDisabled] = useState(true)
    const handleChangePol = (event) =>{
        if(event.target.value =="Yes"){
             setDisabled(false)
        }
        else{
            setDisabled(true)
        }
        props.handler("polysomnography",event)
    }
    useEffect(()=>{
        if(props.data['polysomnography'] =="No"){
            let e = {}
            e.name ='rbd'
            e.value=""
            props.handler("polysomnography",e)
            e.name ='other_abnormalities'
            e.value=""
            props.handler("polysomnography",e)
            e.name= "polysomnography_date"
            props.handler("polysomnography",e)
            
        }
        if(props.data['polysomnography'] =="Yes"){
            setDisabled(false)}
    },[props.data['polysomnography']])
    return(
        <Form>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label>Polysomnography</Form.Label>
                    <Form.Control as={'select'} onChange={handleChangePol} name={"polysomnography"} value={props.data['polysomnography']} disabled={props.edit?true:false}>
                        <option></option>
                        <option>Yes</option>
                        <option>No</option>


                    </Form.Control>
                </Form.Group>
                <Form.Group as={Col}>
                    <Form.Label>RBD </Form.Label>
                    <Form.Control as={'select'} name={'rbd'} onChange={(e)=>props.handler("polysomnography",e)}  value={props.data['rbd']} disabled={props.edit?true:disabled}>
                        <option></option>
                        <option>Yes</option>
                        <option>No</option>


                    </Form.Control>
                </Form.Group>
                <Form.Group as={Col}>
                    <Form.Label>Other anbnormalites </Form.Label>
                    <Form.Control as={'select'} name={'other_abnormalities'} onChange={(e)=>props.handler("polysomnography",e)} value={props.data['other_abnormalities']}disabled={props.edit?true:disabled}>
                        <option></option>
                        <option>Yes</option>
                        <option>No</option>


                    </Form.Control>
                </Form.Group>
                <Form.Group as={Col}>
                        <Form.Label>Date</Form.Label>
                        <Form.Control name={'polysomnography_date'} type={'date'} value={props.data['polysomnography_date']}onChange={(e)=>props.handler("polysomnography",e)} disabled={props.edit? true :disabled}/>
                </Form.Group>
            </Form.Row>
        </Form>
    )
}

export default Polysomnography